import React from "react";
import AddUserModal from "../../common/addUserModal";
import { createCustomer, updateCustomer } from "../../../services/customer.service";
import { customerMessages } from "../../../constants/message.constant";

type CustomerData = {
  id?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  street: string;
  city: string;
  state: string;
  zipcode: string;
};

type AddCustomerModalProps = {
  open: boolean;
  handleClose: (action?: string) => void;
  businessId: string;
  editMode?: boolean;
  customerData?: CustomerData;
};

const AddCustomerModal = ({
  open,
  handleClose,
  businessId,
  editMode = false,
  customerData,
}: AddCustomerModalProps) => {
  return (
    <AddUserModal
      open={open}
      handleClose={handleClose}
      businessId={businessId}
      editMode={editMode}
      userData={customerData}
      title="Customer"
      createUser={createCustomer}
      updateUser={updateCustomer}
      successMessages={{
        add: customerMessages.addCustomer,
        edit: customerMessages.editCustomer,
      }}
      showLeadSearch={!editMode}
    />
  );
};

export default AddCustomerModal;
